import { render, staticRenderFns } from "./VaDataTable.vue?vue&type=template&id=007d4657&"
import script from "./VaDataTable.vue?vue&type=script&lang=js&"
export * from "./VaDataTable.vue?vue&type=script&lang=js&"
import style0 from "./VaDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports